/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * Alchemer Impersonation API
 * OpenAPI spec version: 1.0.44
 */

export type Apps = (typeof Apps)[keyof typeof Apps];

export const Apps = {
  survey: 'survey',
  digital: 'digital',
  dashboard: 'dashboard',
  pulse: 'pulse',
} as const;
